import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import doctorImg from "../../assets/doctors.png";
import { PRI_400 } from "../../theme/colors";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { batalAppointment, getHistoryAppDetail } from "../../redux/actions";
import IconButton from "@mui/material/IconButton";
import SnackBarCustom from "../SnackBarCustom";
import { BASE_URL_IMG } from "../../helpers/common/config";
import { useNavigate } from "react-router-dom";
import { getDetailDokter } from "../../redux/actions/master";
import { ChevronRight } from "@mui/icons-material";
import { Chip } from "@mui/material";

const useStyles = makeStyles({
  img: {
    width: "50px",
    height: "50px",
    objectFit: "contain",
    borderRadius: "50%",
  },
  dateContainer: {
    borderRadius: "8px !important",
    color: "#FFF !important",
    backgroundColor: PRI_400,
    padding: "8px",
  },
  cancelStamp: {
    position: "absolute",
    padding: "8px",
    border: "3px solid red",
    backgroundColor: "#FFF",
    opacity: "0.8",
    color: "red",
    fontSize: "16px",
    width: "50vw",
    fontWeight: 700,
    textAlign: "center",
  },
  qrWrapper: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const CustomChip = ({ isInap = false, idLayanan = 0 }) => {
  let label = "Rawat Jalan";
  let color = "success";

  if (isInap) {
    label = "Rawat Inap";
    color = "warning";
  }

  if (idLayanan === 25) {
    label = "IGD";
    color = "error";
  }

  return (
    <Chip
      label={<Typography variant="body1">{label}</Typography>}
      color={color}
      variant="outlined"
      size="small"
    />
  );
};

const HistoryCard = (props) => {
  const {
    title,
    subtitle,
    tanggal,
    photo,
    doctorId,
    actGetDetailDokter,
    isInap,
    idLayanan,
    rkunId,
    psMr,
    cancelled,
  } = props;
  const navigate = useNavigate();
  const classes = useStyles();
  return (
    <>
      <SnackBarCustom />
      <Paper
        sx={{
          padding: "16px 12px",
          borderRadius: "12px !important",
        }}
        elevation={0}
      >
        <Stack spacing={1} direction="row">
          <CustomChip isInap={isInap} idLayanan={idLayanan} />
          {cancelled && (
            <Chip
              label="Dibatalkan"
              color="error"
              variant="outlined"
              size="small"
            />
          )}
        </Stack>
        <Box height="6px"></Box>
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            container
            spacing={2}
            justifyContent="space-evenly"
            alignItems="center"
          >
            <Grid item>
              <Box
                onClick={() =>
                  actGetDetailDokter(doctorId, () =>
                    navigate(`/doctor-detail/${doctorId}`)
                  )
                }
                // onClick={() => navigate(`/doctor-detail/${doctorId}`)}
              >
                {photo && (
                  <img
                    src={BASE_URL_IMG + "/" + photo}
                    alt=""
                    className={classes.img}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = doctorImg;
                    }}
                  ></img>
                )}
                {!photo && (
                  <img src={doctorImg} alt="" className={classes.img} />
                )}
              </Box>
            </Grid>
            <Grid item>
              <div
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <Stack>
                  <Typography
                    noWrap
                    variant="subtitle2"
                    sx={{
                      width: "10rem",
                    }}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant="body1"
                    noWrap
                    sx={{
                      width: "10rem",
                    }}
                  >
                    {subtitle}
                  </Typography>
                  <Typography
                    variant="body1"
                    noWrap
                    sx={{
                      width: "10rem",
                    }}
                  >
                    {tanggal}
                  </Typography>
                </Stack>
              </div>
            </Grid>
            <Grid item xs={2} container direction="column">
              {!cancelled && (
                <IconButton
                  size="small"
                  onClick={() =>
                    isInap
                      ? navigate(`/history/${rkunId}/${psMr}`)
                      : navigate(`/antrian/${rkunId}/${psMr}`)
                  }
                >
                  <ChevronRight />
                </IconButton>
              )}

              {/* {!isBPJS && onPayment && (
                <IconButton onClick={onPayment} disabled={isPaid()}>
                  <LocalAtm />
                </IconButton>
              )} */}
            </Grid>
          </Grid>
          {/* {cancellable && reservasi && (
            <Grid item xs={12}>
              <Button
                size="small"
                variant="outlined"
                onClick={() => setNotif(true)}
                disabled={cancelled || !reservasi}
              >
                {stateBahasa === "indonesia" ? "Batal" : "Cancel"}
              </Button>
            </Grid>
          )} */}
        </Grid>
      </Paper>
    </>
  );
};
HistoryCard.propTypes = {
  time: PropTypes.string,
  tanggal: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  // cancelled: PropTypes.bool.isRequired,
  rkunId: PropTypes.any.isRequired,
  reservasi: PropTypes.any.isRequired,
  photo: PropTypes.string,
  cancellable: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    // stateEmail: state.auth.email,
    stateBahasa: state.app.bahasa,
    stateHistoryDetail: state.register.historyAppDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actBatalAppointment: (body, action) =>
      dispatch(batalAppointment(body, action)),
    actGetDetailDokter: (body, action) =>
      dispatch(getDetailDokter(body, action)),
    actGetHistoryAppDetail: (body, action) =>
      dispatch(getHistoryAppDetail(body, action)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryCard);
